import {Injectable} from '@angular/core';
import {NavigationStart, Router} from '@angular/router';
import {filter} from 'rxjs';
import {environment} from '../../../environments/environment';
import {HoomvipStorage} from '../hoomvip-storage/hoomvip-storage.service';

@Injectable({providedIn: 'root'})
export class BrandingNavigationInterceptor {
  constructor(
    private router: Router,
    private storage: HoomvipStorage
  ) {
  }

  init(): void {
    this.storage.getBrandingCode();

    this.router.events
      .pipe(filter((event): event is NavigationStart => event instanceof NavigationStart))
      .subscribe(event => this.addBrandingCodeToNavigation(event.url));
  }

  private addBrandingCodeToNavigation(url: string): void {
    if (!this.isDefaultHost()) {
      return;
    }

    const brandingCode = this.storage.getBrandingCode();

    if (!brandingCode) {
      return;
    }

    const urlTree = this.router.parseUrl(url);
    const queryParams = urlTree.queryParams;

    if (queryParams[environment.brandingCodeQueryParam]) {
      return;
    }

    urlTree.queryParams = {
      ...queryParams,
      [environment.brandingCodeQueryParam]: brandingCode,
    };

    this.router.navigateByUrl(urlTree, {
      replaceUrl: true,
    });
  }

  private isDefaultHost(): boolean {
    return window.location.hostname.toLowerCase() === environment.defaultHost.toLowerCase();
  }
}
